import React, { ReactNode } from "react";
import { Button, ButtonProps } from "@mui/joy";
import { ColorPaletteProp } from "@mui/joy/styles";
// import "./styles.css"
interface ReusableButtonProps extends ButtonProps {
  color?: ColorPaletteProp;
  variant?: "outlined" | "solid" | "plain";
  size?: "sm" | "md" | "lg";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  startDecorator?: ReactNode;
  endDecorator?: ReactNode;
  disabled?: any;
  slotProps?: ButtonProps["slotProps"]; 
 sx?: ButtonProps["sx"];
  loading?: boolean;
  fullWidth?: boolean;
  loadingIndicator?: ReactNode;
  loadingPosition?: "start" | "end" | "center";
  title?: string;
  className?:any;
}

const ReuseableButton: React.FC<ReusableButtonProps> = ({
  color,
  variant = "solid",
  size = "md",
  onClick,
  startDecorator,
  endDecorator,
  disabled = false,
  // slotProps,
  sx,
  loading,
  title,
  fullWidth,
  loadingIndicator,
  loadingPosition,
  type,
  className
}) => {
  return (
    <Button
      onClick={onClick}
      color={color}
      variant={variant}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      startDecorator={startDecorator}
      endDecorator={endDecorator}
      loading={loading}
      loadingIndicator={loadingIndicator}
      loadingPosition={loadingPosition}
      sx={sx}
      className={className}
      type={type}
      // slotProps={slotProps} // Spread additional props
    >
      {title}
    </Button>
  );
};

export default ReuseableButton;